import React from "react";
import { Card, Typography, Space, Alert } from "antd";

const { Title, Paragraph, Text } = Typography;

const EmptyState = () => {
  return (
    <Card className="mt-6 text-center min-h-[400px] flex items-center justify-center">
      <Space direction="vertical" size="large" className="max-w-[600px]">
        <Title level={3}>Welcome to Options Simulator</Title>
        <Paragraph type="secondary" className="text-base">
          Analyze options strategies with advanced risk/reward analysis and
          robust strike rankings.
        </Paragraph>
        <Alert
          className="text-left mb-4"
          message="What you can do:"
          description={
            <ul className="pl-5 m-0">
              <li>
                <Text>
                  View dynamic heatmaps showing all strikes across all time
                  periods
                </Text>
              </li>
              <li>
                <Text>
                  Get robust strike rankings that handle signal misses
                </Text>
              </li>
              <li>
                <Text>Analyze risk scenarios with profit/loss breakdowns</Text>
              </li>
              <li>
                <Text>Visualize time decay and performance comparisons</Text>
              </li>
            </ul>
          }
          type="info"
          showIcon
        />
        <Paragraph className="mt-4">
          <Text strong>Get started by selecting a stock symbol above</Text>
        </Paragraph>
      </Space>
    </Card>
  );
};

export default EmptyState;
